import { JobDtoType } from '../domain/jobs';
import { IAccountDetailsDTO } from './accounts.dao';

abstract class IThemesDAO {
    public abstract getThemeList(params?: { accountId: number }): Promise<IThemeDTO[]>;
    public abstract getThemeListByName(name: string): Promise<IThemeDTO[]>;
    public abstract createTheme(themeDetails: ICreateThemeDTO): Promise<IThemeDTO>;
    public abstract updateTheme(themeDetails: IUpdateThemeDTO): Promise<IThemeDTO>;
    public abstract getS3AssetUrl(): Promise<IAssetUrlDTO>;
    public abstract uploadThemeToS3(url: string, themeArchive: Blob): Promise<JobDtoType>;
}

enum Status {
    Pending = 'PENDING',
    Active = 'ACTIVE',
    Failed = 'FAILED',
}

interface IThemeDTO {
    name: string;
    status: Status;
    location: string;
    id: number;
    accounts: null | IAccountDetailsDTO[];
    allAccounts: boolean;
}

interface ICreateThemeDTO {
    name: string;
    themeArchive: File;
    allAccounts: boolean;
    accountIds: null | number[];
}

interface IUpdateThemeDTO {
    id: number;
    name: string;
    location?: string;
    themeArchive?: File;
    allAccounts: boolean;
    accountIds: null | number[];
}
interface IAssetUrlDTO {
    assetUrl: string;
    location: string;
}

export {
    Status,
    IThemeDTO,
    IThemesDAO,
    ICreateThemeDTO,
    IUpdateThemeDTO,
    IAssetUrlDTO
};
